var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('person-banner-layout');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { PersonCell } from './person-cell';
import { useEnv } from '../hooks/use-env';
export var PersonBannerLayoutDefaultProps = {
  hasLabel: true,
  hasControls: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    background: #FFF;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    background: #FFF;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding: ", ";\n  "], ["\n    flex-grow: 1;\n    padding: ", ";\n  "])), theme.UNIT(4))
});
var CellStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(3))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(CellLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Cell: styled(PersonCell)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CellStyles)
};
export var PersonBannerLayout = function (props) {
  var className = props.className,
    hasLabel = props.hasLabel,
    hasControls = props.hasControls,
    entity = props.entity,
    rest = __rest(props, ["className", "hasLabel", "hasControls", "entity"]);
  var env = useEnv();
  var label = props.label || env.PERSON_BANNER_LABEL || 'Profile:';
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, hasLabel && React.createElement(My.Label, null, label), React.createElement(My.Cell, __assign({
    size: "banner",
    entity: entity
  }, rest))));
};
PersonBannerLayout.defaultProps = PersonBannerLayoutDefaultProps;
PersonBannerLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;